import { z } from 'zod';

const envSchema = z.object({
  VITE_APP_NAME: z.string().default('MetaDevProfile'),
  VITE_SERVER_URL: z.string().default('http://localhost:3001'),
  VITE_APP_SLUG: z.string().default('web'),
  VITE_SENTRY_ORG: z.string().default('metadevprofile'),
  VITE_SENTRY_PROJECT: z.string().default('web'),
  VITE_SENTRY_DSN: z
    .string()
    .default('https://90108f29deaa3e248c612453bd594998@o4510559990841344.ingest.de.sentry.io/4510560058277968'),

  VITE_CRISP_WEBSITE_ID: z.string().default('59f7afde-5f8e-40de-9943-6be53afd7efb'),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().default(''),
});

export const _env = envSchema.parse(import.meta.env);

export const env = {
  APP_NAME: _env.VITE_APP_NAME,
  SERVER_URL: _env.VITE_SERVER_URL,
  APP_SLUG: _env.VITE_APP_SLUG,
  SENTRY_DSN: _env.VITE_SENTRY_DSN,
  SENTRY_ORG: _env.VITE_SENTRY_ORG,
  SENTRY_PROJECT: _env.VITE_SENTRY_PROJECT,

  CRISP_WEBSITE_ID: _env.VITE_CRISP_WEBSITE_ID,
  STRIPE_PUBLISHABLE_KEY: _env.VITE_STRIPE_PUBLISHABLE_KEY,
};
